<template lang="html">
  <div class="tour-value">

    <section-intro
      heading="the value of a mobile tour"
      body="Do you have products that benefit from live demonstrations? Take your brand on the road. A well-planned, well-executed mobile event can take your brand directly to the audience."
    ></section-intro>

    <tour-info image="/static/images/case-studies/embraer-ej190/embraer-ej190-hero.jpg">
      An on-site visit allows everyone involved in the purchasing decision to get a hands-on demonstration and sales pitch, without being limited to brochures and first hand accounts of a fraction of the people involved in making the decision.
    </tour-info>
    <tour-info image="/static/images/case-studies/is-da-vinci/is-da-vinci_fp.jpg">
      The difference is equatable to a commercial versus a test drive. Your sales team has to convince a representative from their potential customer to travel in order to experience your product first hand. Typically, this is done at a trade show where your product is never the exclusive topic or demonstration for the day. The sales pitch is then given second hand, and the decision is made without your team's involvement.
    </tour-info>
    <tour-info image="/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_01.jpg">
      A mobile tour changes all of that. Everyone involved in the decision has heard the sales pitch and experienced the product first hand. It's Experimental Marketing. That is the value of a mobile show room. Your product is innovative and extraordinary, surely it would sell itself if only you could get it in front of your customers.
    </tour-info>

  </div>

</template>

<script>
  // eslint-disable-next-line no-unused-vars
  import { TweenMax, TimelineMax, Linear } from 'gsap'
  import SectionIntro from '@/components/SectionIntro'
  import TourInfo from '@/components/TourInfo'
  export default {
    components: {
      'section-intro': SectionIntro,
      'tour-info': TourInfo
    },
    name: 'tour-value',
    mounted () {
      this.$nextTick(this.parallaxImg)
    },
    data () {
      return {
      }
    },
    methods: {
      parallaxImg () {
        const floaters = document.querySelectorAll('.ti-img__floater')

        floaters.forEach((floater, i) => {
          const tl = new TimelineMax()

          tl.set(floaters[i], { y: 100 })
            .to(floaters[i], 0.5, { y: 0, ease: Linear.easeInOut })
          const scene = new this.$scrollmagic.Scene({
            triggerElement: floater,
            duration: '100%',
            triggerHook: 1,
            reverse: true
          }).setTween(tl)
          this.$ksvuescr.$emit('addScene', 'parallaxImg', scene)
        })
      }
    },
    destroyed () {
      // Destroy ScrollMagic when our component is removed from DOM
      this.$ksvuescr.$emit('destroy')
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';
</style>



// WEBPACK FOOTER //
// src/components/TourValue.vue